﻿import Vue from 'vue';
const users_Sites = {
  state: {
    users_Sites: [],
    filtered: []
  },

  getters: {
    users_Sites(state) {
      return state.users_Sites;
    },
    filtered(state) {
      return state.filtered;
    }
  },

  mutations: {
    getUsers_Sites(state, payload) {
      state.users_Sites = payload;
    },
    getFiltered(state, payload) {
      state.filtered = payload;
    },
  },

  actions: {
    getUsers_Sites(context, payload) {
      const url = 'Users_Sites';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getUsers_Sites', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    getFiltered(context, payload) {
      const url = 'Users_Sites/Search';
      Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.commit('getFiltered', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    updateUsers_Sites(context, payload){
      const url = `Users_Sites/${ payload.ID }`;
      Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('getUsers_Sites')
            context.dispatch('getFiltered', {UserName: '', Site: ''})
          },
          (error) => {
            console.log(error);
          },
        );
    },
    createUsers_Sites(context, payload){
      const url = `Users_Sites`;
      Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('getUsers_Sites')
            context.dispatch('getFiltered', {UserName: '', Site: ''})
          },
          (error) => {
            console.log(error);
          },
        );
    },
    deleteUsers_Sites(context, payload){
      const url = `Users_Sites/${ payload.ID }`;
      Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('getUsers_Sites')
            context.dispatch('getFiltered', {UserName: '', Site: ''})
          },
          (error) => {
            console.log(error);
          },
        );
    }
  },
}

export default users_Sites